<template>
  <v-container fluid class="pa-4">
    <h3 class="text-center mt-10">
      {{ $tt('customFreeDashBoardText1') }}
    </h3>
    <v-layout align-center justify-center class="mt-4">
      <v-img max-width="303" contain src="/images/freeTop.png" />
    </v-layout>
    <v-layout align-center justify-center>
      <v-sheet class="mt-10 pa-4">
        <v-layout align-start justify-space-around>
          <v-layout align-start justify-start>
            <h4>{{ $tt('customContractPlanTitle') }}</h4>
            <p class="ml-2 pa-0">Free</p>
          </v-layout>
        </v-layout>
        <v-layout align-start justify-start class="mt-4">
          <v-btn style="text-transform: none" outlined @click="openProfessionalPlan()">
            {{ $tt('customUpgradeToProfessionalText') }}
          </v-btn>
        </v-layout>
      </v-sheet>
    </v-layout>
    <!-- Plan選択ダイアログ -->
    <v-dialog v-model="isShowingPurchaseWizard" persistent max-width="50rem">
      <select-plan-component
        @closeNowLoading="closeNowLoading"
        @openNowLoading="openNowLoading"
        @closePurchaseWizardDialog="closePurchaseWizardDialog"
        @subscribe="subscribe"
        @selectBillingPlan="selectedBillingPlan = $event"
        @selectPaymentMethodType="selectedPaymentMethodType = $event"
        @inputCouponCode="couponCode = $event"
        @setStripeAddCardRequest="addCardRequest = $event"
        :plan="plan"
      />
    </v-dialog>
    <!-- nowLoading -->
    <now-loading-overlay-component :nowLoading="nowLoading" />

    <!-- 購入完了ダイアログ -->
    <v-dialog v-model="isShowBuyComplete" persistent max-width="30rem">
      <v-card>
        <v-card-title class="">
          {{ $tt('customBillingMessageSubscribe') }}
        </v-card-title>
        <v-card-text>
          <v-chip class="mb-1" x-small v-if="displayBuyCompleteData.trial">
            {{ $tt('customBillingTrial') }}
          </v-chip>
          <div>{{ $tt('customPlan') }} : {{ displayBuyCompleteData.plan }}</div>
          <div>{{ $tt('customBillingAmount') }} : {{ displayBuyCompleteData.amount }}</div>
          <div>
            {{ $tt('customBillingContractPeriod') }} : {{ displayBuyCompleteData.startedAt | aidToYearMonthDay }}
            -
            {{ displayBuyCompleteData.expiredAt | aidToYearMonthDay }}
          </div>
          <div v-if="displayBuyCompleteData.invoiceUrl !== null && displayBuyCompleteData.trial === false">
            {{ $tt('customBillingReceipt') }} <br />
            <v-btn
              v-if="displayBuyCompleteData.invoiceUrl !== null && displayBuyCompleteData.trial === false"
              icon
              color="grey darken-3"
              :href="displayBuyCompleteData.invoiceUrl"
              target="_blank"
            >
              <v-icon>receipt</v-icon>
            </v-btn>
          </div>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeBuyCompletedDialod()">
            {{ $tt('customClose') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as Constants from '@/lib/constants'
import Toast from '@/lib/toast'
import SelectPlanComponent from '@/components/billing/SelectPlanComponent'
import NowLoadingOverlayComponent from '@/components/NowLoadingOverlayComponent'
import BillingMixin from '@/components/mixins/billing-mixin'
import * as Filter from '@/lib/filters'
import storage from '@/lib/storage'

export default {
  name: 'FreeDashBoard',
  components: {
    SelectPlanComponent,
    NowLoadingOverlayComponent,
  },
  mixins: [BillingMixin],
  data() {
    return {
      isShowingPurchaseWizard: false,
      purchaseWizardStep: 1,
      nowLoading: false,
      plan: null,
      isShowBuyComplete: false,
      displayBuyCompleteData: {
        plan: '',
        amount: 0,
        expiredAt: '',
        startedAt: '',
        invoiceUrl: '',
        trial: false,
      },
    }
  },
  mounted() {
    this.$store.dispatch('getStripeInfo')
  },
  methods: {
    openProfessionalPlan() {
      this.plan = Constants.PROFESSIONAL_PLAN
      this.openSelectPlanComponent()
    },
    openSelectPlanComponent() {
      this.planMode = this.plan
      this.isShowingPurchaseWizard = true
    },
    subscribe() {
      this.openNowLoading()
      const params = {
        planId: this.selectedBillingPlan.id,
        addCardRequest: this.addCardRequest,
        couponCode: null,
        paymentMethodTypes: this.selectedPaymentMethodType.value,
        onSuccess: this.onSubscribeSuccess,
        onFailure: this.onSubscribeFailure,
      }

      if (this.couponCode) {
        params.couponCode = this.couponCode
      }
      this.$store.dispatch('subscribeStripePlan', params)
    },
    onSubscribeSuccess() {
      // TokenによってPermissionが変わるのでトークンを取り直す
      const params = {
        onSuccess: this.onRefreshTokenSuccess,
      }
      this.$store.dispatch('authRefreshToken', params)
    },
    onRefreshTokenSuccess() {
      const params = {
        onSuccess: this.onGetStripeInfoSuccess,
      }
      this.$store.dispatch('getStripeInfo', params)
    },
    onGetStripeInfoSuccess() {
      this.closeNowLoading()
      this.closePurchaseWizardDialog()
      const params = {
        onSuccess: this.onGetMeSuccess,
      }
      this.$store.dispatch('authGetMe', params)
    },
    onGetMeSuccess() {
      // 表示は API の正式名 (AgriBus Professional)。this.plan は識別子
      this.displayBuyCompleteData.plan = (this.selectedBillingPlan && this.selectedBillingPlan.displayName) || this.plan
      let amount = this.selectedBillingPlan.amount
      if (this.couponCode) {
        const coupons = this.$store.getters.coupons
        const coupon = coupons.find(coupon => coupon.id === this.couponCode)
        amount = amount - coupon.amountOff
      }
      const purchaseInfo = storage.getPurchaseInfo().purchaseInfo
      if (purchaseInfo.purchases.length > 0) {
        const purchase = purchaseInfo.purchases[0]
        this.displayBuyCompleteData.invoiceUrl = purchase.invoiceUrl
        if (amount > 0) {
          this.displayBuyCompleteData.amount = Filter.aidFormatPrice(amount, purchase.currency)
        }
      }
      this.displayBuyCompleteData.trial = purchaseInfo.trial
      this.displayBuyCompleteData.startedAt = purchaseInfo.planStartedAt
      this.displayBuyCompleteData.expiredAt = purchaseInfo.planExpiredAt
      this.isShowBuyComplete = true
    },
    onSubscribeFailure() {
      this.closeNowLoading()
      this.closePurchaseWizardDialog()
      if (this.couponCode) {
        Toast.i18nError('customStandardSubscribeErrorMessage')
      }
    },

    closeBuyCompletedDialod() {
      this.isShowBuyComplete = false
      this.$router.push({ name: 'Feed' })
    },

    closeNowLoading() {
      this.nowLoading = false
    },
    openNowLoading() {
      this.nowLoading = true
    },
    closePurchaseWizardDialog() {
      this.closeNowLoading()
      this.isShowingPurchaseWizard = false
      this.purchaseWizardStep = 1
    },
  },
}
</script>

<style scoped></style>
